module.exports = __webpack_public_path__ + "339b534bc29e368900f1409b4c027b9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/OneAleiraBG.jpg
// module id = 36
// module chunks = 0